import { render, staticRenderFns } from "./BookingsPayout.vue?vue&type=template&id=638a644a&scoped=true"
import script from "./BookingsPayout.vue?vue&type=script&lang=ts"
export * from "./BookingsPayout.vue?vue&type=script&lang=ts"
import style0 from "./BookingsPayout.vue?vue&type=style&index=0&id=638a644a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a644a",
  null
  
)

export default component.exports